import React, { Component } from "react";
import { ReactSketchCanvas } from "react-sketch-canvas";

class ReactSketchCanvasComponent extends Component {
  constructor(props) {
    super(props);
    this.canvas = React.createRef();
  }
  state = {
    styles: {
      border: "0.0625rem solid #9c9c9c",
      borderRadius: "0.25rem",
      objectFit: "contain",
    },
    previewImg: null,
    isChange: false,
  };

  render() {
    const { Bs, backgroundImage, SIZE } = this.props;
    return (
      <Bs row className="h-450">
        <Bs
          button
          size={SIZE.SM}
          variant="secondary"
          disabled={!this.state.isChange}
          onClick={() => {
            this.canvas.current.clearCanvas();
            this.setState({ isChange: false });
          }}
        >
          Vyčistit
        </Bs>

        <ReactSketchCanvas
          ref={this.canvas}
          style={this.state.styles}
          backgroundImage={backgroundImage}
          strokeWidth={3}
          strokeColor="red"
          width={JSON.parse(localStorage.getItem("webCam")).width}
          height={JSON.parse(localStorage.getItem("webCam")).height}
          exportWithBackgroundImage={true}
          onStroke={() => this.setState({ isChange: true })}
        />
        <Bs
          button
          size={SIZE.SM}
          variant="success"
          disabled={!this.state.isChange}
          onClick={() => {
            this.canvas.current
              .exportImage("png")
              .then((data) => {
                this.props.editImg(data);
                this.canvas.current.clearCanvas();
                this.setState({ isChange: false });
              })
              .catch((e) => {
                console.log(e);
              });
          }}
        >
          Uložit
        </Bs>
      </Bs>
    );
  }
}

export default ReactSketchCanvasComponent;
